import { Message } from "../const/message";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
export default {
    name: "TemplateListTable",
    props: {
        searchedTemplates: { type: Array, default: () => [] },
        deleteTemplate: {
            type: Function,
            required: true,
        },
        getTemplate: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            isAllSelected: false,
            showContent: false,
            showModalDelete: false,
            pageTemplateList: [],
            displayTemplates: [],
            pageNum: 0,
            nowPage: 1,
            pagenation: [],
            selectedPage: [],
            template: "",
        };
    },
    components: {
        QuillEditor,
    },
    methods: {
        calcPageNum(value) {
            // クリックされた値を現在のページに上書き
            this.nowPage = value;
            let firstPage = this.nowPage - 2;
            let lastPage = this.nowPage + 2;
            if (this.pageNum <= 5) {
                // ページの総数が5ページ以下の場合
                firstPage = 1;
                lastPage = this.pageNum;
            }
            else if (this.nowPage === 1 || this.nowPage === 2) {
                // 現在のページが1,2ページ目の場合
                firstPage = 1;
                lastPage = 5;
            }
            else if (this.nowPage === this.pageNum - 1 ||
                this.nowPage === this.pageNum) {
                // 現在のページが最終,最終の一つ前ページ目の場合
                firstPage = this.pageNum - 4;
                lastPage = this.pageNum;
            }
            this.pagenation = [];
            for (let i = firstPage; i <= lastPage; i++) {
                this.pagenation.push(i);
            }
        },
        isFormat(page) {
            // 追加するスタイル格納用配列初期化
            let addStyle = {};
            // 現在表示中のページかどうか
            if (page === this.nowPage) {
                // 現在表示中のページのスタイルを追加
                addStyle["color"] = "white";
                addStyle["backgroundColor"] = "gray";
            }
            // 現在表示中のページが１ページ目かどうか
            if (page === 1 && this.nowPage === 1) {
                addStyle["border-top-left-radius"] = "0.25rem";
                addStyle["border-bottom-left-radius"] = "0.25rem";
            }
            // 現在表示中のページが最終ページ目かどうか
            if (page === this.pageNum && this.nowPage === this.pageNum) {
                addStyle["border-top-right-radius"] = "0.25rem";
                addStyle["border-bottom-right-radius"] = "0.25rem";
            }
            this.selectedPage[page] = addStyle;
            return addStyle;
        },
        async openModal(template) {
            let body = await this.getTemplate(template.templateId);
            this.template = template;
            this.$refs.myEditor.setHTML(body);
            this.showContent = true;
        },
        closeModal() {
            this.template = [];
            this.$refs.myEditor.setHTML("");
            this.showContent = false;
        },
        openModalDelete(template) {
            this.template = template;
            this.showModalDelete = true;
        },
        closeModalDelete() {
            if (!this.showContent) {
                this.template = [];
            }
            this.showModalDelete = false;
        },
        async deleteClick() {
            await this.deleteTemplate(this.template.templateId);
            this.showModalDelete = false;
            this.closeModal();
        },
        edit(template) {
            this.$router.push({
                name: "template-update",
                params: {
                    templateId: template.templateId,
                },
                query: {
                    templateId: template.templateId,
                    division: template.division,
                    crmGetFlg: template.crmGetFlg,
                    releaseTime: template.releaseTime,
                    title: template.title,
                    sub: template.sub,
                },
            });
        },
    },
    watch: {
        searchedTemplates(templates) {
            // ページごとの学校リスト初期化
            this.pageTemplateList = [];
            // テーブルに表示する学校の配列を初期化
            this.displayTemplates = [];
            // 現在ページの番号を初期化
            this.nowPage = 1;
            // ページネーション番号を初期化
            this.pagenation = [];
            // ページの表示件数ごとに全学校リストを分割
            while (templates.length)
                this.pageTemplateList.push(templates.splice(0, Message.TEMPLATE.DISPLAY_NUMBER));
            // ページ数を取得
            this.pageNum = this.pageTemplateList.length;
            // ページネーション番号のセット
            if (this.pageNum <= 5) {
                // ページ番号が5以下の場合、ページ番号のみのページネーション番号をセット
                for (let i = 1; i <= this.pageNum; i++) {
                    this.pagenation.push(i);
                }
            }
            else {
                // 5ページ目までのページネーション番号をセット
                this.pagenation = [1, 2, 3, 4, 5];
            }
            // 表示ページのデータ配列を更新
            this.displayTemplates = this.pageTemplateList[this.nowPage - 1];
        },
        nowPage: function () {
            // 表示ページのデータ配列を更新
            this.displayTemplates = this.pageTemplateList[this.nowPage - 1];
        },
    },
};
